if($('.type-detail').length){
    if($('.p-short-description').length){
        var maxLength = 200;
        var description = $('.p-short-description');
        var fullHtml = description.html();
        var textLength = description.text().length;
        if (textLength > maxLength) {
          var shortHtml = $('<div/>').html(fullHtml).text().substr(0, maxLength) + '...';
          description.html('<p class="shortDescription">'+shortHtml+'</p>');
          var readMoreBtn = $('<span/>', {
            text: 'Číst více',
            class: 'read-more-btn',
            click: function () {
              var btnText = $(this).text();
              if (btnText === "Číst více") {
                description.html(fullHtml);
                $(this).text("Zobrazit méně");
              } else {
                description.html('<p class="shortDescription">'+shortHtml+'</p>');
                $(this).text("Číst více");
              }
            }
          });
          description.after(readMoreBtn);
        }
    }

    $(document).ready(function() {
        var storedData = sessionStorage.getItem('ratingData');
        if (storedData) {
            $('.p-detail-inner').after(storedData);
        } else {
            $.ajax({
                url: '/hodnoceni-obchodu/',
                type: 'GET',
                success: function(response) {
                    var content = $(response);
                    var ratingsFinal = content.find('.votes-wrap').html();
                    var finalHtml = '<div class="StoreRating">'
                    finalHtml += '<div class="ratingTitle">Jak o nás mluví zákazníci</div>'
                    finalHtml += '<div class="votes-wrap">'+ratingsFinal+'</div>'
                    finalHtml += '<div class="text-right"><a href="/hodnoceni-obchodu/">Zobrazit další hodnocení ››</a></div>'
                    finalHtml += '</div>'
                    
                    $('.p-detail-inner').after(finalHtml)
    
                    sessionStorage.setItem('ratingData', finalHtml);
                },
                error: function(xhr, status, error) {
                    console.error("Error fetching rating data:", status, error);
                }
            });
        }
    });

}

